export default __webpack_public_path__ + "static/logo_ElNorte-cfbbd324add4d0826f24063647dbe80f.svg";